module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Db-Fb-Ge-Hc-Ia.20a8ebea.png";